import Link from 'next/link';
import React, { useCallback } from 'react';
import { useAppState } from '../../../client/providers/AppProvider';
import { Espin_Role_Enum, PlayerCardFragment } from '../../../generated/spin-graphql';
import { usePlayersSearchContext } from '../../../pages/players';
import { PlayerCard } from '../card/PlayerCard';
import { PlayerShowMoreSearchResultsButton } from './PlayerShowMoreSearchResultsButton';

export function PlayerListDisplay({
    searchPlayers,
}: {
    searchPlayers: (s: string, filtersActive: boolean, offset: number, isLoadMore: boolean) => Promise<any>;
}) {
    const { data: players } = usePlayersSearchContext();

    const { subscribed, user } = useAppState();
    // in here, check the data + our user details.
    // if it's empty + i'm an subbed college, then no results.
    // if it's empty + otherwise, upsell to subscribe as a college!
    // if i'm a player + i search, i'll get myself - just show upsell.
    return (
        <>
            {user?.role === Espin_Role_Enum.EspinCollegeUser && subscribed && (
                <div className="container players-list-cards">
                    {players.map((player: PlayerCardFragment, index: number) => (
                        <PlayerCard key={`subbed-college-card-${index}`} player={player} />
                    ))}
                    <PlayerShowMoreSearchResultsButton searchPlayers={searchPlayers} />
                </div>
            )}
            {(user?.role !== Espin_Role_Enum.EspinCollegeUser || !subscribed) && (
                <div className="container players-list-cards">
                    <div className="subscribe-card">
                        <h2 className="title">Available to Subscribing Colleges Only</h2>
                        <p className="subtitle">Check out all of the available perks here!</p>
                        <Link href={`/pricing`}>
                            <a className="button medium-button blue-button">View Perks</a>
                        </Link>{' '}
                    </div>
                </div>
            )}
        </>
    );
}
